import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { Facebook, Instagram, Linkedin } from "react-bootstrap-icons";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./Header.css";
import { WhatsApp } from "@mui/icons-material";
import { Link as ScrollLink } from "react-scroll";
import { SOCIALS, IMAGES } from "../../config/site";

function Header() {
  const [collapseOpened, setCollapseOpened] = useState(false);

  return (
    <div className="header">
      <Navbar
        expand="lg"
        variant="secondary"
        className="bg-color"
        expanded={collapseOpened}
      >
        <Container fluid>
          <ScrollLink
            to="home"
            smooth={true}
            duration={500}
            className="navbar-brand"
            onClick={() => setCollapseOpened(false)}
            style={{ cursor: "pointer" }}
          >
            <Image
              src={IMAGES.logo}
              width="50"
              height="50"
              className="d-inline-block align-top rounded-circle"
              alt="Nawel BOUCHOUKH - ZEVA, Psychologue clinicienne, TCC, PARIS, Villejuif"
            />
          </ScrollLink>
          <div className="navbar-brand-text">
            <Navbar.Text className="Navbar-Text">Cabinet ZEVA</Navbar.Text>
            <div className="zeva-meaning">
              Zénitude, Évolution, Valeurs et Action
            </div>
          </div>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setCollapseOpened(!collapseOpened)}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <ScrollLink
                to="navbar-overview"
                smooth={true}
                duration={500}
                offset={-80}
                className="hover-effect nav-link scroll-link active"
                activeClass="active"
                onClick={() => setCollapseOpened(false)}
              >
                À propos
              </ScrollLink>
              <ScrollLink
                to="office"
                smooth={true}
                duration={500}
                offset={-80}
                className="hover-effect nav-link scroll-link active"
                activeClass="active"
                onClick={() => setCollapseOpened(false)}
              >
                Cabinet
              </ScrollLink>
              <ScrollLink
                to="contact"
                smooth={true}
                duration={500}
                offset={-80}
                className="hover-effect nav-link scroll-link active"
                activeClass="active"
                onClick={() => setCollapseOpened(false)}
              >
                Contact
              </ScrollLink>
            </Nav>
            <Navbar.Text>
              <div className="social-icons">
                <a
                  href={SOCIALS.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                >
                  <Linkedin />
                </a>{" "}
                &nbsp;
                <a
                  href={SOCIALS.facebook}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <Facebook />
                </a>{" "}
                &nbsp;
                <a
                  href={SOCIALS.instagram}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <Instagram />
                </a>
                &nbsp;
                <a
                  href={SOCIALS.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="WhatsApp"
                >
                  <WhatsApp />
                </a>
              </div>
            </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;
